// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"RoomFacilitiesOverlayLayout-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/RoomFacilitiesOverlayLayout/RoomFacilitiesOverlayLayout.desktop.scss
 ** module id = 958
 ** module chunks = 1
 **/